import moment from 'moment';

/**
 * Ride class
 * @param {?Number} id
 * @param {?Number} timeDriven
 * @param {?Number} timePaused
 * @param {?Boolean} startedInZone
 * @param {?Date} startedAt
 * @param {?Date} endedAt
 * @param {?Entries} entries
 */
export default class User {
  constructor() {
    this.id = null;
    this.timeDriven = null;
    this.timePaused = null;
    this.startedInZone = null;
    this.startedAt = null;
    this.endedAt = null;

    this.entries = null;
  }

  set startedAt(value) {
    this._startedAt = value;
  }

  get startedAt() {
    return this._startedAt !== null ? moment(this._startedAt) : null;
  }

  set endedAt(value) {
    this._endedAt = value;
  }

  get endedAt() {
    return this._endedAt !== null ? moment(this._endedAt) : null;
  }
}
